import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'emptyPlaceHolder',
  standalone: true
})

export class EmptyPlaceHolderPipe<T> implements PipeTransform {
  transform(value: T): string | T {
    if (!value || value.toString().trim() === '') {
      return '—'
    }
    return value
  }
}